import type { DefaultOptions } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";

const ONE_MINUTE_MS = 60_000;
const FIVE_MINUTES_MS = 300_000;

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: ONE_MINUTE_MS,
    gcTime: FIVE_MINUTES_MS,
    refetchOnWindowFocus: true,
    retry: 2,
  },
  mutations: {
    retry: 0,
  },
};

export function createQueryClient() {
  return new QueryClient({
    defaultOptions,
  });
}

let client: QueryClient | undefined;

export function getQueryClient() {
  if (typeof window === "undefined") {
    return createQueryClient();
  }

  if (!client) {
    client = createQueryClient();
  }

  return client;
}
